/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Profile_Edit_LabelInputs */

const es_user_profile_edit_label = /** @type {(inputs: User_Profile_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar Perfil`)
};

const en_user_profile_edit_label = /** @type {(inputs: User_Profile_Edit_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Profile`)
};

/**
* | output |
* | --- |
* | "Edit Profile" |
*
* @param {User_Profile_Edit_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const user_profile_edit_label = /** @type {((inputs?: User_Profile_Edit_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Profile_Edit_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_user_profile_edit_label(inputs)
	return en_user_profile_edit_label(inputs)
});
export { user_profile_edit_label as "user.profile.edit.label" }